import React, { forwardRef, ReactNode } from 'react';
import clsx from 'clsx';
import { Check } from 'lucide-react';
import styles from './Checkbox.module.scss';

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: ReactNode;
  error?: string;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, error, className, ...props }, ref) => {
    return (
      <div className={styles.wrapper}>
        <label className={styles.container}>
          <div className={styles.inputWrapper}>
            <input
              type="checkbox"
              ref={ref}
              className={clsx(styles.checkbox, { [styles.hasError]: error }, className)}
              {...props}
            />
            <Check size={14} className={styles.checkIcon} strokeWidth={3} />
          </div>
          {label && <span className={styles.label}>{label}</span>}
        </label>
        {error && <span className={styles.errorText}>{error}</span>}
      </div>
    );
  }
);

Checkbox.displayName = 'Checkbox';
